import { useState } from 'react';

export type DeviceTestStatus = 'idle' | 'loading' | 'processing' | 'failure' | 'success';

export const useDeviceTest = () => {
  const [status, setStatus] = useState<DeviceTestStatus>('idle');

  return [status, setStatus] as const;
};
